import React from "react";

export const BranchTallyUploadDetailContext = React.createContext(null);

export const useBranchTallyUploadDetailContext = () => {
  const context = React.useContext(BranchTallyUploadDetailContext);
  if (!context) {
    throw new Error("Branch Tally Upload Detail Context not provided!");
  }
  return context;
};
